/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApprovalDecision } from './approvalDecision';

export type ApproveModuleVersionBody = ApprovalDecision | null;
